import '../../../node_modules/goodshare.js/goodshare.min';

export default class Social {
  constructor() {
    this.socialScrolled = document.querySelector('.social--scrolled');
    this.newsViewTop = document.querySelector('.news-view__top');
    this.previewFullLength = document.querySelector(
      '.preview-image--full-length'
    );
    this.indentFromPreview = 80;
  }

  setTopForSocial() {
    let offsetTopSocial
    if (this.newsViewTop) {
      offsetTopSocial = this.newsViewTop.offsetHeight + this.previewFullLength.offsetHeight;

    }

    this.socialScrolled.style.top = `${offsetTopSocial + this.indentFromPreview}px`;
  }

  getHeightFromTop() {
    const socialWrapper = this.socialScrolled.querySelector('.social__wrapper');
    window.addEventListener('scroll', () => {
      this.socialScrolled.getBoundingClientRect().y - 30 <= 0
        ? socialWrapper.classList.add('social__wrapper--fixed')
        : socialWrapper.classList.remove('social__wrapper--fixed');
    });
  }

  init() {
    window.innerWidth > 1024 && this.socialScrolled && this.getHeightFromTop();

    if (this.previewFullLength) {
      this.setTopForSocial();
    }
  }
}
